import Button, { IProps as IButtonProps, Preset } from '../Button';
import Spinner from '../Spinner';
import { Children } from 'react';

import './styles.scss';

interface IProps extends IButtonProps {
  big?: boolean; // button size
  loading?: boolean;
  text?: string;
}

export function TextButton({
  children,
  className = '',
  big = false,
  preset = Preset.Primary,
  loading = false,
  text,
  ...remainingProps
}: IProps) {
  const mergedClassName = ['text-button', big && 'big', className]
    .filter(Boolean)
    .join(' ');

  const renderedChildren = () => {
    if (loading) return <Spinner color="white" />;
    if (Children.count(children) > 0) return children;

    return text;
  };

  return (
    <Button {...remainingProps} className={mergedClassName} preset={preset}>
      {renderedChildren()}
    </Button>
  );
}
